import successPlanIcon from 'assets/successplan-icon.png'
import supportPlanIcon from 'assets/supportplan-icon.png'
import timeBasedIcon from 'assets/timebased-icon.png'

import newSuccessPathIcon from 'assets/SuccessPath.svg'
import newRapidOutcomeIcon from 'assets/SuccessService.svg'
import newAssuranceServicesIcon from 'assets/AssuranceService.svg'
import newVrdIcon from 'assets/ValueReadyDeployment.svg'
import adoptionPackageIcon from 'assets/AdoptionPackage.svg'
import jumpStartIcon from 'assets/JumpStart.svg'
import sparkIcon from 'assets/Spark.svg'
import optimizationIcon from 'assets/Optimization.svg'
import pacesetterIcon from 'assets/Pacesetter.svg'
import applicationConsultingIcon from 'assets/ApplicationConsulting.svg'
import transformationServicesIcon from 'assets/TransformationServices.svg'
export const NEW_ICONS = {
  vrd: newVrdIcon,
  successpath: newSuccessPathIcon,
  successplan: successPlanIcon,
  successservice: newRapidOutcomeIcon,
  supportplan: supportPlanIcon,
  timebased: timeBasedIcon,
  rapidoutcome: newRapidOutcomeIcon,
  assuranceservices: newAssuranceServicesIcon,
  adoptionpackage: adoptionPackageIcon,
  jumpstart: jumpStartIcon,
  spark: sparkIcon,
  optimization: optimizationIcon,
  pacesetter: pacesetterIcon,
  applicationconsulting: applicationConsultingIcon,
  transformationservices: transformationServicesIcon,
}

export const PILL_COLORS = {
  vrd: '#ff4949',
  successpath: '#fdc973',
  successplan: '#e2700c',
  successservice: '#5bb745',
  supportplan: '#00afcc',
  timebased: '#0075be',
  rapidoutcome: '#5bb745',
  assuranceservices: '#00afcc',
}

export const COL_SIZE = {
  lg: 8,
  md: 10,
  sm: 12,
  xs: 12,
}

export const SHOW_DECISION_TREE = /dev|localhost/.test(window.location.hostname)

export const CATEGORY_CLASS_NAME_MAPPING = [
  { category: 'vrd', className: 'vrd' },
  { category: 'value ready deployment', className: 'vrd' },
  { category: 'success path', className: 'successpath' },
  { category: 'success plan', className: 'successplan' },
  { category: 'success service', className: 'successservice' },
  { category: 'support plan', className: 'supportplan' },
  { category: 'time-based service', className: 'timebased' },
  { category: 'rapid outcome', className: 'rapidoutcome' },
  { category: 'assurance services', className: 'assuranceservices' },
  { category: 'adoption package', className: 'adoptionpackage' },
  { category: 'jump start', className: 'jumpstart' },
  { category: 'spark', className: 'spark' },
  { category: 'optimization', className: 'optimization' },
  { category: 'pacesetter', className: 'pacesetter' },
  { category: 'application consulting', className: 'applicationconsulting' },
  { category: 'transformation services', className: 'transformationservices' },
]
